import { useEffect, useState, useContext } from "react";
import { Navigate, useParams } from "react-router";
import { UserContext } from "../UserContext";
import TextEditor from "../Editor";
import config from "../config";

export default function EditPage() {
  const { userInfo } = useContext(UserContext);

  const { id } = useParams();

  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [content, setContent] = useState("");
  const [files, setFiles] = useState("");
  const [redirect, setRedirect] = useState("");

  useEffect(() => {
    fetch(`${config.apiUrl}/post/` + id).then((response) => {
      response.json().then((postContent) => {
        setTitle(postContent.title);
        setSummary(postContent.summary);
        setContent(postContent.content);
      });
    });
  }, [id]);

  async function updatePost(ev) {
    ev.preventDefault();
    const data = new FormData();
    data.set("title", title);
    data.set("summary", summary);
    data.set("content", content);
    data.set("id", id);

    if (files?.[0]) {
      data.set("files", files[0]);
    }

    const response = await fetch(`${config.apiUrl}/edit`, {
      method: "PUT",
      body: data,
      credentials: "include",
    });

    if (response.ok) {
      setRedirect(true);
    } else {
      response
        .json()
        .then((errorData) => {
          alert(errorData.error || "An error occurred");
        })
        .catch((error) => {
          console.error("Failed to parse JSON", error);
          alert("An unexpected error occurred");
        });
    }
  }

  if (redirect) {
    return <Navigate to={"/post/" + id} />;
  }

  const privelages = userInfo?.isAdmin;

  return (
    <>
      {!privelages && <h1>You cant acces this resources</h1>}
      {privelages && (
        <form className="create" onSubmit={updatePost}>
          <h1>Edit this post</h1>
          <input
            type="text"
            placeholder={"Title"}
            value={title}
            onChange={(ev) => setTitle(ev.target.value)}
          />
          <input
            type="text"
            placeholder={"Summary"}
            value={summary}
            onChange={(ev) => setSummary(ev.target.value)}
          />
          <input type="file" onChange={(ev) => setFiles(ev.target.files)} />

          <TextEditor content={content} setContent={setContent} />
          <button className="forms-button">
            <span>Update Post</span>
          </button>
        </form>
      )}
    </>
  );
}
